<template>
  <Teleport to="body">
    <div v-if="globalLoading" :style="overlayStyle" class="global-loading-overlay">
      <div :style="loadingWrapperStyle" class="loading-wrapper">
        <div class="loader">
          <span>{{ globalLoadingConfig.text }}</span>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { useGlobalLoading } from '@/hooks/useGlobalLoading'
import { computed } from 'vue'

// 直接使用全局状态
const { globalLoading, globalLoadingConfig } = useGlobalLoading()

const overlayStyle = computed(() => {
  return {
    backgroundColor: globalLoadingConfig.fullscreen ? 'white' : 'transparent',
  }
})

const loadingWrapperStyle = computed(() => {
  return {}
})
</script>

<style lang="less">
body .global-loading-overlay {
  position: fixed !important;
}

.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9999999999999;
}

.loading-wrapper {
  position: absolute;
  top: 40%;
  padding: 24px 50px 24px 50px;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.9);

  .loader {
    width: fit-content;
    font-weight: 500;
    font-family: monospace;
    font-size: 22px;
    background: radial-gradient(circle closest-side, #0274F7 94%, #0000) right/calc(200% - 1em) 100%;
    animation: l24 1s infinite alternate linear;
  }

  .loader span {
    line-height: 1em;
    color: #0000;
    background: inherit;
    background-image: radial-gradient(circle closest-side, #fff 94%, #0274F7);
    -webkit-background-clip: text;
    background-clip: text;
  }

  @keyframes l24 {
    100% {
      background-position: left
    }
  }
}
</style>
